import * as Utils from '../../Utils';

var keyModifier = Utils.getKeyModifier();

var defaultKeymap = {
    CollapsablePanel: {
        PANEL_TOGGLE: 'enter',
        PANEL_PIN: 'shift+enter',
    },
};

export default defaultKeymap;
